export enum PlatformHubTemplateType {
    ProjectTemplate = "ProjectTemplate",
    ProcessTemplate = "ProcessTemplate",
}

import type { SimpleMenuItem } from "@octopusdeploy/design-system-components";
import { dividerMenuItem } from "@octopusdeploy/design-system-components";
import type { GitLinkResult } from "@octopusdeploy/octopus-server-client";
import { Permission } from "@octopusdeploy/octopus-server-client";
import { isAllowed } from "~/components/PermissionCheck/PermissionCheck";

interface ProjectTemplateOverflowMenuItemsArgs {
    projectTemplateLink: GitLinkResult | null;
    onShare: () => void;
    isShared: boolean;
    onStopShare: () => void;
    additionalItems?: SimpleMenuItem[];
}
export default function createProjectTemplateOverflowMenuItems({ projectTemplateLink, onShare, isShared, onStopShare, additionalItems }: ProjectTemplateOverflowMenuItemsArgs) {
    const menuItems: SimpleMenuItem[] = [];

    if (isAllowed({ permission: Permission.PlatformHubEdit })) {
        menuItems.push({ type: "button", label: "Share", onClick: onShare });
    }

    if (additionalItems) {
        menuItems.push(...additionalItems);
    }

    if (projectTemplateLink?.Link) {
        menuItems.push({ type: "external-link", label: "View source code", href: projectTemplateLink.Link });
    } else {
        menuItems.push({ type: "disabled", label: "View source code", disableReason: "Link unavailable" });
    }

    if (isAllowed({ permission: Permission.PlatformHubEdit })) {
        menuItems.push(dividerMenuItem);
        if (isShared) {
            menuItems.push({ type: "button", isDestructive: true, label: "Stop sharing this template", onClick: onStopShare });
        } else {
            menuItems.push({ type: "disabled", label: "Stop sharing this template", disableReason: "Template is not shared" });
        }
    }

    return menuItems;
}
